import type { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

const postPasswordResetRequest: DocumentNode = gql`
  mutation PostPasswordResetRequest($email: EmailAddress!) {
    postPasswordResetRequest(input: { email: $email }) {
      message
    }
  }
`

export default postPasswordResetRequest
